import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { Product } from '@mews-commander/data-access';
import { LocalizedProperty, lt } from '@mews/framework';
import { Typography } from '@optimus-web/core';
import { ProductCounts } from './types';

const columnHelper = createColumnHelper<Product>();

export const useColumns = (counts: ProductCounts) =>
    useMemo(
        () => [
            columnHelper.accessor('names', {
                header: () => lt('ProductPlural'),
                cell: (props) => (
                    <Typography textStyle="bodyMedium" as="div">
                        <LocalizedProperty property={props.getValue()} />
                    </Typography>
                ),
            }),
            columnHelper.accessor('id', {
                header: () => lt('TotalAmount'),
                cell: (props) => (
                    <Typography textStyle="bodyMedium" as="div">
                        {counts[props.getValue()] || null}
                    </Typography>
                ),
                meta: { align: 'end' },
            }),
        ],
        [counts]
    );
